import { atom } from 'jotai'
import { BusinessCustomerType, CustomerWallet, IndividualCustomerType } from 'types/customers'
import { CustomerModel } from '../helpers/types'

export const customerModelAtom = atom<CustomerModel>()
export const currentCustomerAtom = atom<BusinessCustomerType | IndividualCustomerType>()
export const currentCustomerWalletAtom = atom<CustomerWallet>()
